// extracted by mini-css-extract-plugin
module.exports = {"submenu":"styles__submenu--3QFEn","list":"styles__list--3MiRl","featured":"styles__featured--2FnUp"};
    if(module.hot) {
      // 1541451133835
      var cssReload = require("!../../../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  